type Rol = "Omic" | "Admin"

interface Menu {
    title: string;
    path: string;
    rolesAllowed?: Rol[];
    subRolesAllowed?: string[];
    subItems?: Menu[];
    headerTitle?: string;
    headerSubTitle?: string;
    show?: boolean;
}

export const MenuData: Menu[] = [{
    title: "Mesa de entrada",
    path: "mesa-de-entrada",
    rolesAllowed: ["Admin", "Omic"],
    headerTitle: "Mesa de entrada",
    headerSubTitle: "Acá podras ver los reclamos sin asignar, asignados y filtrarlos por el sistema de semáforos.",
    show: true,
},
    , {
    title: "Reclamos IVE",
    path: "reclamos-hv",
    rolesAllowed: ["Admin"],
    headerTitle: "Mesa de reclamos IVE",
    headerSubTitle: "Acá podras ver los reclamos y sus diferentes estados.",
    show: true,
},
{
    title: "Instructivo",
    path: "manual-de-uso",
    //rolesAllowed: ["Admin", "Omic"],
    headerTitle: "Instructivo",
    headerSubTitle: "Guía de utilización"
},
{
    title: "Mi perfil",
    path: "perfil",
    //rolesAllowed: ["Admin", "Omic"],
    headerTitle: "Perfil de usuario",
    headerSubTitle: "Ver y modificar tu perfil"
},
{
    title: "Gestión de usuarios",
    path: "gestion-de-usuarios",
    rolesAllowed: ["Admin"],
    subRolesAllowed: ["apGeneral"],
    subItems: [
        {
            title: "Crear nuevo usuario",
            path: "gestion-de-usuarios/crear-usuario",
            rolesAllowed: ["Admin"],
            headerTitle: "Datos del usuario",
            headerSubTitle: "Modifique los datos, seleccione el tipo de rol y accesos que tendrá este usuario.",
            show: true
        },
        {
            title: "Crear nuevo usuario",
            path: "gestion-de-usuarios/editar-usuario/:id",
            rolesAllowed: ["Admin"],
            headerTitle: "Datos del usuario",
            headerSubTitle: "Modifique los datos, seleccione el tipo de rol y accesos que tendrá este usuario.",
            show: false
        },
        {
            title: "Listado general de usuarios",
            path: "gestion-de-usuarios/listado-de-usuarios",
            rolesAllowed: ["Admin"],
            headerTitle: "Tablero de gestión administrativa",
            headerSubTitle: "A continuación podrás ver el listado general de usuarios.",
            show: true
        },
    ],
    show: true,
},
{
    title: "Estandares y protocolos",
    path: "estandares-y-protocolos",
    rolesAllowed: ["Admin", "Omic"],
    headerTitle: "Biblioteca de estándares y protocolos",
    headerSubTitle: "Acá podrás consultar y descargar la información que necesites",
    show: false,
},
{
    title: "Reclamo",
    path: "mesa-de-entrada/reclamo/:id",
    rolesAllowed: ["Admin", "Omic"],
    headerTitle: "Gestión de reclamo",
    headerSubTitle: "Acá podras ver la información detallada y gestionar sus avances",
    show: false,
},
{
    title: "Reclamo IVE",
    path: "reclamos-hv/reclamo-ive/:id",
    rolesAllowed: ["Admin"],
    headerTitle: "Mesa de entrada",
    headerSubTitle: "Acá podras ver los reclamos sin asignar, asignados y filtrarlos por el sistema de semáforos.",
    show: false,
},
{
    title: "Buzón general de Tickets",
    path: "tickets",
    rolesAllowed: ["Admin"],
    headerTitle: "Buzón de Tickets ",
    headerSubTitle: "Acá podrás gestionarlos y darle el seguimiento que cada ticket necesita",
    show: true,
},
{
    title: "Buzón general de Tickets",
    path: "tickets/:id",
    rolesAllowed: ["Admin"],
    headerTitle: "Buzón de Tickets ",
    headerSubTitle: "Acá podrás gestionarlos y darle el seguimiento que cada ticket necesita",
    show: false,
}
]